var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHiddenPwIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible 1",
    clipPath: "url(#clip0_1560_6422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8164 8.19605L15.252 11.6316L15.2684 11.4517C15.2684 9.64661 13.8014 8.17969 11.9964 8.17969L11.8164 8.19605Z",
    fill: "#DEDEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9986 6.00007C15.0088 6.00007 17.4519 8.44317 17.4519 11.4534C17.4519 12.1569 17.3101 12.8276 17.0647 13.4438L20.2549 16.634C21.9018 15.2598 23.1997 13.482 24.0013 11.4534C22.109 6.66541 17.4574 3.27344 11.9986 3.27344C10.4717 3.27344 9.01022 3.54609 7.65234 4.03688L10.0082 6.38724C10.6243 6.14731 11.2951 6.00007 11.9986 6.00007Z",
    fill: "#DEDEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.09064 3.02731L3.57735 5.51402L4.07362 6.01029C2.27403 7.41724 0.850716 9.28774 0 11.4527C1.88686 16.2407 6.54397 19.6326 11.9973 19.6326C13.6878 19.6326 15.302 19.3054 16.7799 18.711L17.2434 19.1746L20.4227 22.3593L21.8133 20.9741L2.48124 1.63672L1.09064 3.02731ZM7.12203 9.05323L8.80711 10.7383C8.75803 10.9728 8.72531 11.2073 8.72531 11.4527C8.72531 13.2577 10.1922 14.7247 11.9973 14.7247C12.2427 14.7247 12.4772 14.6919 12.7062 14.6429L14.3913 16.3279C13.666 16.6878 12.8589 16.906 11.9973 16.906C8.98706 16.906 6.54397 14.4629 6.54397 11.4527C6.54397 10.5911 6.76212 9.78396 7.12203 9.05323Z",
    fill: "#DEDEE4"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_6422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenPwIcon);
export default __webpack_public_path__ + "static/media/hidden-pw-icon.6170d1523e8f6485d58b53eacab57bdd.svg";
export { ForwardRef as ReactComponent };